module.exports = __webpack_public_path__ + "img/escrows-gray.fc356103.svg";